import { render, staticRenderFns } from "./prjIdSelect.vue?vue&type=template&id=54c359ff&scoped=true&lang=pug"
import script from "./prjIdSelect.vue?vue&type=script&lang=js"
export * from "./prjIdSelect.vue?vue&type=script&lang=js"
import style0 from "./prjIdSelect.vue?vue&type=style&index=0&id=54c359ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c359ff",
  null
  
)

export default component.exports